export default __webpack_public_path__ + "static/chili1-b3824d95b67f3988a4878635fb8ea22c.jpg";